import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", end: true },
  { label: "影视剧", to: "/category/film-tv", end: false },
  { label: "综艺现场", to: "/category/variety", end: false },
  { label: "音乐现场", to: "/category/music", end: false },
  { label: "时尚造型", to: "/category/fashion", end: false },
  { label: "关于我们", to: "/about", end: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-[68px] max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="黑瓜吃料 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl text-foreground-950">黑瓜吃料</span>
            <span className="mt-0.5 text-[10px] tracking-[0.18em] text-foreground-500">
              瓜田连线
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                [
                  "whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/about#connect"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-send-plane-fill text-sm" />
            </span>
            投稿连线
          </Link>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-3 md:px-6" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  [
                    "flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100",
                  ].join(" ")
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </NavLink>
            ))}
            <Link
              to="/about#connect"
              className="mt-2 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-send-plane-fill text-sm" />
              </span>
              投稿连线
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}